import React, { useState } from "react";
import { NuUpload } from "./Inputs";
import { CloseIcon } from "../assets/icons";
import useAddData from "../hooks/useAddData";
import { CancelButton, SubmitButton } from "./Button";
import { RemoveApprovel } from "./RemoveApprovel";

function CommonImport({ url, refreshData, getFuction, visible=false, onClose,hasRemoveApproval=false,moduleId="",standardId=""}) {
  const { isCreateLoading, addData } = useAddData();
  const [files, setFiles] = useState(null);
  function handleImageChange(e) {
    const { files, value } = e.target;
    setFiles(files);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("file", files[0]);
    await addData({
      url: url,
      value: formdata,
      resetForm: setFiles(null),
      onClose: onClose,
      getData: refreshData,
      otherFunction: getFuction,
      customMsg: "Data Successfully Imported",
    });
    if(hasRemoveApproval){
      RemoveApprovel({moduleId:moduleId,standardId:standardId});
    }
  };

  const handleClose = () => {
    setFiles(null);
    onClose();
  };

  if(!visible) return null;

  return (
    <>
      <div
        id="modal" className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm flex justify-center items-center z-10">
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-xs 2xl:text-sm font-semibold">Import</h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={() => handleClose()}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="relative flex flex-wrap justify-between">
              <NuUpload
                label="File"
                width="w-full"
                onChange={handleImageChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              />
            </div>
            <div className=" w-full flex items-center px-3 mt-2 justify-end pb-6 rounded-b">
              <CancelButton onClose={handleClose} isLoading={isCreateLoading} />
              <SubmitButton isLoading={isCreateLoading} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default CommonImport;
